<section class="mission-vision">

    <div class="container-redesign">

        <div class="mission-vision__grid">

            <article
                *ngFor="let card of cards; trackBy: trackByTitle"
                class="mission-vision__card">

                <img
                    [src]="card.icon"
                    [alt]="card.title"
                    class="mission-vision__icon">

                <h2 class="mission-vision__title">
                    {{ card.title }}
                </h2>

                <p
                    *ngFor="let paragraph of card.paragraphs; trackBy: trackByIndex"
                    class="mission-vision__paragraph">

                    {{ paragraph }}

                </p>

            </article>

        </div>

    </div>

</section>